import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { OneBtnModal, TwoBtnModal } from "components/common/modal";
import { NoticeInfoTable } from "components/notice/detail";
import { PrimaryBtn, AddBtn } from "components/common/button";
import {
  getNoticeDetail,
  postNotice,
  putNotice,
  delNotice,
} from "service/api/notice";
import responseCodeConstant from "service/constant/responseCodeConstant";
import type { INoticeList } from "service/interface/notice";
import routerConstant from "service/constant/routerConstant";

export function NoticeDetailPage() {
  const params = useParams();
  const navigate = useNavigate();
  const [detailData, setDetailData] = useState<INoticeList>({} as INoticeList);
  const [isSuccessModalVisible, setIsSuccessModalVisible] =
    useState<boolean>(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] =
    useState<boolean>(false);
  const [isDeleteSuccessModalVisible, setIsDeleteSuccessModalVisible] =
    useState<boolean>(false);

  useEffect(() => {
    if (params.id) {
      if (params.id !== "add") {
        (async () => {
          const detailRes = await getNoticeDetail(params.id + "");
          if (detailRes.status === responseCodeConstant.SUCCESS.ok) {
            setDetailData(detailRes.data.data);
          }
        })();
      }
    }
  }, [params]);

  const handleDeleteBtn = () => {
    setIsDeleteModalVisible(true);
  };

  const handleDeleteModalBtn = async () => {
    const delRes = await delNotice(params.id + "");
    if (delRes.status === responseCodeConstant.SUCCESS.ok) {
      setIsDeleteSuccessModalVisible(true);
    }
  };

  const handleDeleteSuccessModalBtn = () => {
    navigate(routerConstant.NOTICE.list);
  };

  const handleSaveBtn = async () => {
    if (params.id === "add") {
      const addRes = await postNotice({
        title: detailData.title,
        content: detailData.content,
        link: detailData.link,
      });
      if (addRes.status === responseCodeConstant.SUCCESS.ok) {
        setIsSuccessModalVisible(true);
      }
    } else {
      const saveRes = await putNotice({
        noticeId: params.id,
        body: {
          title: detailData.title,
          content: detailData.content,
          link: detailData.link,
        },
      });
      if (saveRes.status === responseCodeConstant.SUCCESS.ok) {
        setIsSuccessModalVisible(true);
      }
    }
  };

  const handleSuccessBtn = () => {
    navigate(routerConstant.NOTICE.list);
  };

  return (
    <>
      <OneBtnModal
        isVisible={isSuccessModalVisible}
        setIsVisible={setIsSuccessModalVisible}
        title={params.id === "add" ? "저장 완료" : "수정 완료"}
        subTitle={
          params.id === "add" ? "저장 완료되었습니다" : "수정 완료되었습니다"
        }
        btnLabel="확인"
        btnClick={params.id === "add" ? handleSuccessBtn : () => {}}
      />
      <OneBtnModal
        isVisible={isDeleteSuccessModalVisible}
        setIsVisible={setIsDeleteSuccessModalVisible}
        title="삭제 완료"
        subTitle="삭제 완료되었습니다"
        btnLabel="확인"
        btnClick={handleDeleteSuccessModalBtn}
      />
      <TwoBtnModal
        isVisible={isDeleteModalVisible}
        setIsVisible={setIsDeleteModalVisible}
        title="해당 게시글을 삭제하시겠습니까?"
        subTitle=""
        btnLabel="삭제하기"
        btnClick={handleDeleteModalBtn}
      />
      <div className="h-full min-h-[100vh] w-[calc(100%-273px)] bg-[#fdfdfd]">
        <div className="mx-auto w-[1167px] p-[78px_80px_72px_64px]">
          <p className="m-0 mb-[8px] text-[16px] font-semibold leading-[20px] text-gray-4 opacity-[0.5]">
            메모리올 관리자 화면
          </p>
          <div className="flex items-center justify-between">
            <p className="m-0 text-[32px] font-medium leading-[40px] text-black">
              공지사항 관리
            </p>
            {params.id !== "add" && (
              <AddBtn isRemove onClick={handleDeleteBtn} />
            )}
          </div>
          <div className="mt-[32px] flex flex-col gap-[28px] rounded-[12px] bg-white p-[48px_40px_64px_48px] shadow-[0px_0px_8px_rgba(0,0,0,0.1)]">
            <NoticeInfoTable data={detailData} setData={setDetailData} />
            <div className="flex items-center justify-end">
              <PrimaryBtn
                label="저장하기"
                isDisabled={!detailData.content || !detailData.title}
                onClick={handleSaveBtn}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
